var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useState } from 'react';
import useVgsPaymentConfig from './useVgsPaymentConfig';
import { injectVgs } from './vgsUtils';
export default function useConfigureVgs() {
    var _a = __read(useState(false), 2), isVgsSciptLoaded = _a[0], setIsVgsSciptLoaded = _a[1];
    var _b = __read(useState(''), 2), errorMessage = _b[0], setErrorMessage = _b[1];
    var _c = useVgsPaymentConfig(), vgsConfig = _c.vgsConfig, isVgsProviderEnabled = _c.isVgsProviderEnabled;
    useEffect(function () {
        if (isVgsSciptLoaded) {
            return;
        }
        else if (!isVgsSciptLoaded && !isVgsProviderEnabled) {
            setErrorMessage('Failed to load vgs provider');
            return;
        }
        injectVgs(vgsConfig)
            .then(function () {
            setIsVgsSciptLoaded(true);
        })
            .catch(function (err) {
            setErrorMessage(err.message);
        });
    }, [isVgsSciptLoaded, isVgsProviderEnabled, vgsConfig]);
    var result = [
        isVgsSciptLoaded,
        errorMessage,
        vgsConfig,
    ];
    return result;
}
